import classNames from 'clsx'
import { arrayOf, func, shape, string } from 'prop-types'
import { connectMenu } from 'react-instantsearch-dom'

import IconCaretDown from 'views/components/atoms/Icon/IconCaretDown'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import { interact } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/helpers'
import Collapsible from 'views/components/organisms/Collapsible'

import { parseCategories } from './helpers'

import './CategoryList.scss'

// eslint-disable-next-line react/prop-types
const ListItem = ({ item, refine, attribute, isLast, isSelected }) => {
  const { label, value, count, level, hideCount } = item
  const className = classNames(`m-CategoryList--item-${level}`, {
    'u-margin-xx-small--bottom': !isLast,
    'u-font-weight--bold': isSelected,
  })

  return (
    <li className={className}>
      <ButtonAsLink
        name={`category-list-${attribute}-${label}`}
        left
        onClick={interact(refine, value)}
      >
        {isSelected ? (
          <IconCaretDown size="small" />
        ) : (
          <IconCaretRight size="small" />
        )}
        <span>
          {label} {!hideCount && `(${count})`}
        </span>
      </ButtonAsLink>
    </li>
  )
}

ListItem.propTypes = {
  item: shape({}).isRequired,
}

const CategoryList = ({
  items,
  attribute,
  refine,
  label,
  currentRefinement,
  className,
}) => {
  const id = `category-list-${attribute}`
  const parsedItems = parseCategories(items, currentRefinement)
  const selectedCategory = currentRefinement?.split('/').pop()?.trim()

  const shouldRenderCategoryList = Boolean(parsedItems?.length)
  const divClass = classNames(
    'm-CategoryList',
    'u-no-border-radius u-border--bottom u-padding@small-tiny',
    {
      'u-hidden': !shouldRenderCategoryList,
    },
    className
  )
  return (
    <div className={divClass}>
      <Collapsible
        id={id}
        label={label}
        expanded
        inFilter
        headingLevel="p"
        forceDisplayWhenCollapsed
      >
        {shouldRenderCategoryList && (
          <div className="u-padding--sides@small-tiny">
            <ul className="a-list-reset">
              {parsedItems.map((item, index) => (
                <ListItem
                  key={index}
                  isLast={index + 1 === parsedItems.length}
                  // selected
                  isSelected={item.label === selectedCategory}
                  {...{
                    item,
                    attribute,
                    refine,
                  }}
                />
              ))}
            </ul>
          </div>
        )}
      </Collapsible>
    </div>
  )
}

CategoryList.propTypes = {
  label: string.isRequired,
  attribute: string.isRequired,
  items: arrayOf(shape({})).isRequired,
  refine: func.isRequired,
  currentRefinement: string,
  className: string,
}

CategoryList.defaultProps = {
  currentRefinement: null,
  className: null,
}

export default connectMenu(CategoryList)
